<template>
  <div class="w-full">
    <div class="sticky top-0 z-10 flex items-center justify-between h-16 px-4 bg-white border-b lg:px-6">
      <h1 class="text-lg font-bold">
        New Address
      </h1>
    </div>
    <div class="px-4 py-3 border-b lg:px-6 bg-gray-50">
      <router-link :to="{ name: 'CustomerAddressList' }" class="text-accent">
        &larr; Back to Address Book
      </router-link>
    </div>
    <div class="max-w-lg p-4 lg:p-6">
      <customer-address-form mode="create" @success="success" />
    </div>
  </div>
</template>

<script>
import CustomerAddressForm from './CustomerAddressForm'

export default {
  name: 'CustomerAddressCreate',

  components: {
    CustomerAddressForm
  },

  data () {
    return {
      loading: true,
      address: {}
    }
  },

  methods: {
    async success () {
      this.$toasted.show('Address Created')
      this.$router.push({ name: 'CustomerAddressList' })
    }
  }
}
</script>
